module.exports = __webpack_public_path__ + "static/media/popupimg2.44110bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/03/components/c02_a03_tab_02/assets/popupimg2.jpg
// module id = 451
// module chunks = 0